import axios from 'axios';
import { getUserData, saveUserData } from './storageService';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://backend-c-0mxm.onrender.com';
const API_URL = BASE_URL.replace(/\/api$/, '');

const getAuthHeaders = () => {
  const user = getUserData();
  return {
    Authorization: `Bearer ${user?.userId || ''}`
  };
};

const avatarService = {
  // Upload avatar
  upload: async (file) => {
    const formData = new FormData();
    formData.append('avatar', file);

    const response = await axios.post(`${API_URL}/api/auth/avatar`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data',
      },
    });

    // Update user data in localStorage with new avatar
    if (response.data.success) {
      const userData = getUserData();
      if (userData) {
        saveUserData({ ...userData, avatar: response.data.avatar });
      }
    }

    return response.data;
  },

  // Delete avatar
  delete: async () => {
    const response = await axios.delete(`${API_URL}/api/auth/avatar`, {
      headers: getAuthHeaders(),
    });

    // Update user data in localStorage
    if (response.data.success) {
      const userData = getUserData();
      if (userData) {
        saveUserData({ ...userData, avatar: null });
      }
    }

    return response.data;
  },

  // Get initials from name for default avatar
  getInitials: (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  },

  // Get avatar color based on name
  getColor: (name) => {
    if (!name) return '#6366f1';
    const colors = [
      '#f43f5e', '#ec4899', '#d946ef', '#a855f7', '#8b5cf6',
      '#6366f1', '#3b82f6', '#0ea5e9', '#06b6d4', '#14b8a6',
      '#10b981', '#22c55e', '#84cc16', '#eab308', '#f59e0b',
      '#f97316', '#ef4444',
    ];
    const index = name.charCodeAt(0) % colors.length;
    return colors[index];
  },
};

export default avatarService;
